import { useAppSelector } from '@/shared/store/hooks';
import { applyUpdate } from './registerSW';

export interface UpdateServiceWorkerState {
  /** Hay una versión nueva de la app esperando. */
  updateAvailable: boolean;
  /** Activa la versión nueva; la página se recarga sola. */
  applyUpdate: () => void;
}

export function useUpdateServiceWorker(): UpdateServiceWorkerState {
  const updateAvailable = useAppSelector((state) => state.ui.updateAvailable);
  return { updateAvailable, applyUpdate };
}
